import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reset",
  "use": "reset-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"reset\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 2a6 6 0 00-6 6v1.803l1.709-1.78A.75.75 0 117.291 9.06l-3 3.126a.75.75 0 01-1.082 0l-3-3.126a.75.75 0 111.082-1.038L3 9.803V8a7.5 7.5 0 117.5 7.5h-.375a.75.75 0 110-1.5h.375a6 6 0 000-12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol